var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty1Semnomeacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12 12)",
    id: "KakQ1aUgCWvXCGEIAOTOI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(252,210,29)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-11.99526, -12)",
    d: "M 11.9953 2 C 6.44985 2 1.94922 6.48 1.94922 12 C 1.94922 17.52 6.44985 22 11.9953 22 C 17.5407 22 22.0413 17.52 22.0413 12 C 22.0413 6.48 17.5407 2 11.9953 2 Z M 10.9907 17 L 10.9907 15 L 12.9999 15 L 12.9999 17 L 10.9907 17 Z M 10.9907 7 L 10.9907 13 L 12.9999 13 L 12.9999 7 L 10.9907 7 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4476744559 0 0 1.3359973615 12 9.9994487321)",
    id: "3qfY8MxF8RMN10sETyONV"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(251,100,130)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0.000005, 0.000005)",
    d: "M -2.27564 -2.27564 L 2.2756299999999996 -2.27564 L 2.2756299999999996 2.2756299999999996 L -2.27564 2.2756299999999996 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.98676957 16.0220507166)",
    id: "yfIe12PlxVts17kA0Kmzg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(96,71,97)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1.045205, -1.045205)",
    d: "M 0 0 L 2.09041 0 L 2.09041 2.09041 L 0 2.09041 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Semnomeacao);
export default __webpack_public_path__ + "static/media/Property 1=sem nomeacao.a5780f63e5d3f8e399e8992d2e91dc1f.svg";
export { ForwardRef as ReactComponent };